<template>
  <div class="login">
    <template v-if="failed">
      <div class="alert alert-danger">
        We were unable to log you in.
      </div>
    </template>
    <template v-else>
      <loading-screen :show="true" />
    </template>
  </div>
</template>

<script>
import LoginFunctions from '../controllers/Login'
import LoadingScreen from '@/components/modules/LoadingScreen'
import { routes } from '@/router'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Login',
  components: {
    LoadingScreen
  },
  data: () => ({
    failed: false
  }),
  computed: {
    ...mapGetters({
      accountToken: 'accountToken',
      loginUrl: 'loginUrl'
    })
  },
  created () {
    if (this.$route.name === 'LoginExpired') {
      window.location.href = this.loginUrl
    } else {
      this.getConfig()
    }
  },
  methods: {
    /**
     * To fetch API settings
     * @function
     * @returns {undefined}
     */
    getConfig () {
      LoginFunctions.getConfig()
        .then(response => {
          if (response.payload) {
            this.setApis(response.payload.apis)
            this.setEnvironment(response.payload.environment)
            this.setGoogleMapsApiKey(response.payload.googleMapsApiKey)
            this.setLoginUrl(response.payload.loginUrl)
            this.login(this.$route.query.token)
          }
        })
        .catch(reason => {
          this.failed = true
        })
    },
    /**
     * To fetch ecomm settings
     * @function
     * @param {object} token - The auth token
     * @returns {undefined}
     */
    login (token) {
      LoginFunctions.login(token)
        .then(response => {
          this.setAccountToken(token)

          /* eslint-disable no-undef */
          this.setAppId(response.App.app_id)
          localStorage.setItem('appId', response.App.app_id)

          this.setAppSecret(response.App.app_secret)
          localStorage.setItem('appSecret', response.App.app_secret)

          this.setUserToken(response.session.token)
          localStorage.setItem('userToken', response.session.token)

          this.$root.activeUser = response.payload
          const activeUser = JSON.stringify(this.$root.activeUser)
          localStorage.setItem('activeUser', activeUser)

          this.$root.createdBy = response.session.admin_id
          localStorage.setItem('createdBy', response.session.admin_id)

          let userRoles = response.payload.roles
          this.$root.roles = userRoles
          localStorage.setItem('roles', JSON.stringify(response.payload.roles))

          let userPermissions = {}
          for (const permission of response.payload.assigned_permissions) {
            userPermissions[permission.name] = true
          }
          this.setPermissions(userPermissions)

          if (response.payload.type === 'admin') {
            this.$root.accountType = 'application_admin'
          } else if (response.payload.type === 'restricted') {
            this.$root.accountType = 'store_admin'
            this.setStoreLocations(response.payload.locations)
          }
          localStorage.setItem('accountType', this.$root.accountType)
          /* eslint-enable no-undef */

          let appRoutes = routes.filter(route => route.path === '/app')[0]
            .children
          let accessible = false
          // eslint-disable-next-line
          const routePath = sessionStorage.getItem("routePath");
          for (let i = 0; i < appRoutes.length; i++) {
            const route = appRoutes[i]
            accessible = route.meta.permissions.some(
              permission => this.$root.permissions[permission]
            )
            if (accessible) {
              if (routePath !== null) {
                const routePathAccessible = appRoutes.find(route => {
                  if (`/app/${route.path}` === routePath) {
                    return route.meta.permissions.some(
                      permission => this.$root.permissions[permission]
                    )
                  }
                })
                if (routePathAccessible) {
                  this.$router.push({
                    path: routePath
                  })
                } else {
                  this.$router.push({
                    path: `/app/${route.path}`
                  })
                }
              } else {
                this.$router.push({
                  path: `/app/${route.path}`
                })
              }
              break
            }
          }
          if (!accessible) {
            this.$router.push('/app/unauthorized')
          }
        })
        .catch(reason => {
          window.location.href = this.loginUrl
        })
    },
    ...mapMutations({
      setAccountToken: 'SET_ACCOUNT_TOKEN',
      setApis: 'SET_APIS',
      setAppId: 'SET_APP_ID',
      setAppSecret: 'SET_APP_SECRET',
      setEnvironment: 'SET_ENVIRONMENT',
      setGoogleMapsApiKey: 'SET_GOOGLE_MAPS_API_KEY',
      setPermissions: 'SET_PERMISSIONS',
      setLoginUrl: 'SET_LOGIN_URL',
      setStoreLocations: 'SET_STORE_LOCATIONS',
      setUserToken: 'SET_USER_TOKEN'
    })
  }
}
</script>

<style scoped>
.login {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
}
.alert {
  max-width: 768px;
}
</style>
